@let commonData = commonDataService.getData() | async;

<p>{{ commonData?.copyRights }}</p>

<img
  src="assets/images/{{ commonData?.footerImg }}"
  [alt]="commonData?.footerAlt"
  [width]="commonData?.footerImgWidth"
  [height]="commonData?.footerImgHeight"
  class="mt-4"
/>
